<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Категории ресторанов</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3">
                        <CButton color="primary" @click="addType">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Название</th>
                                    <th>Код</th>
                                    <th>Картинка</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <draggable v-model="types" tag="tbody" handle=".handle">
                                <tr v-for="type in types" :key="type.id">
                                    <td width="40">
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" />
                                    </td>
                                    <td>{{ type.title }}</td>
                                    <td>{{ type.code }}</td>
                                    <td>
                                        <CImg
                                            v-if="type.picture"
                                            :src="pictureUrl(type.picture)"
                                            class="m2"
                                            width="80" />
                                    </td>
                                    <td width="140">
                                        <CButton color="light" class="mr-2" @click="editType(type)">
                                            <CIcon :content="$options.icons.cilPencil" />
                                        </CButton>
                                        <CButton color="danger" @click="removeType(type)">
                                            <CIcon :content="$options.icons.cilTrash" />
                                        </CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" class="mr-3" @click="saveOrder">Сохранить порядок</CButton>
                    <CButton color="light" @click="goBack">Назад</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <RestaurantTypeUpsertDialog
            ref="upsertDialog"
            :entity="selectedType"
            @success="fetch"
        />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import RestaurantTypeUpsertDialog from '@/components/RestaurantTypeUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'RestaurantTypes',
        components: {
            draggable,
            RestaurantTypeUpsertDialog,
            AppConfirmDialog,
        },
        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },
        data() {
            return {
                types: [],
                selectedType: null,
            };
        },
        async created() {
            await this.fetch();
        },
        methods: {
            async fetch() {
                try {
                    const { data } = await Vue.axios.get('/restaurant-types');
                    this.types = Array.isArray(data) ? data : [];
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки категорий.');
                }
            },
            pictureUrl(picture) {
                return picture ? `${process.env.VUE_APP_STATIC_BASE_URL}/${picture}` : '';
            },
            addType() {
                this.selectedType = {};
                this.$refs.upsertDialog.open();
            },
            editType(type) {
                this.selectedType = { ...type };
                this.$refs.upsertDialog.open();
            },
            removeType(type) {
                this.selectedType = type;
                this.$refs.confirmDialog.open();
            },
            async confirmDelete() {
                if (!this.selectedType || !this.selectedType.id) {
                    return;
                }
                try {
                    await Vue.axios.delete(`/restaurant-types/${this.selectedType.id}`);
                    await this.fetch();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка удаления категории.');
                }
            },
            async saveOrder() {
                try {
                    const payload = this.types.map((type, index) => ({
                        id: type.id,
                        position: index + 1
                    }));
                    await Vue.axios.post('/restaurant-types/reorder', { reorder: payload });
                    this.$root.$emit('showAlert', 'Порядок сохранен.');
                    await this.fetch();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения порядка.');
                }
            },
            goBack() {
                this.$router.push({ path: '/settings/restaurants' });
            }
        }
    };
</script>

<style scoped>
.handle {
    cursor: grab;
}
</style>
